import React, { useState } from 'react';
import './antd.form.css';
import './user-management.css';
import patterns from '../../config/patterns';
import { ButtonType, TAButton, TAPasswordInput } from '../widgets';
import authService from '../../services/auth.service';
import { Form } from 'antd';

export const ChangePasswordForm: React.FC<any> = ({ onError, onSubmit, onSuccess }) => {
	const [error, setError] = useState<any>();
	const [confirmDirty, setConfirmDirty] = useState<any>();
	const [form] = Form.useForm();
	const checkIfEqualFirstPassword = (rule, value, callback) => {
		if (value) {
			if (value !== form.getFieldValue('password'))
				return callback('Two passwords that you entered are inconsistent!');
			else if (value === form.getFieldValue('currentPassword'))
				return callback('The new password has to be different from current password.');
		}
		return callback();
	};

	const checkIfEqualConfirmationPassword = (rule, value, callback) => {
		if (value) {
			if (value === form.getFieldValue('currentPassword'))
				return callback('The new password has to be different from current password.');
			if (confirmDirty) {
				return form.validateFields(['confirmPassword']);
			}
			return callback();
		}
	};

	const onFinish = async values => {
		onSubmit && onSubmit();
		try {
			await authService.changePassword(values);
		} catch (e: any) {
			setError(e.message);
			onError && onError(e.message);
			return;
		}

		setError(null);
		form.setFieldsValue(values);
		onSuccess && onSuccess();
		return;
	};

	return (
		<Form layout="vertical" className="ta-form" onFinish={onFinish} form={form}>
			<Form.Item
				label="Current Password"
				name="currentPassword"
				rules={[
					{ required: true, message: 'Please enter you current password.' },
					{
						pattern: patterns.passwordPattern,
						message:
							'Password must contain at lease one alphabet and one number and be more than 8 characters'
					}
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item
				label="New Password"
				name="password"
				rules={[
					{ required: true, message: 'Please enter password.' },
					{
						pattern: patterns.passwordPattern,
						message:
							'Password must contain at least one alphabet and one number and be more than 8 characters'
					},
					{ validator: checkIfEqualConfirmationPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item
				label="Confirm Password"
				name="confirmPassword"
				rules={[
					{ required: true, message: 'Please enter password confirmation.' },
					{ validator: checkIfEqualFirstPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item>
				<TAButton
					htmlType="submit"
					style={{
						width: '100%',
						padding: '.8rem 0.8rem',
						borderRadius: '.9rem',
						fontSize: '.9rem',
						fontWeight: 500,
						lineHeight: '1.36',
						height: 'auto'
					}}
					btntype={ButtonType.PRIMARY}
				>
					Save
				</TAButton>
			</Form.Item>
		</Form>
	);
};
